import { render, staticRenderFns } from "./HistoryFlash.vue?vue&type=template&id=55ab0a91&scoped=true"
import script from "./HistoryFlash.vue?vue&type=script&lang=js"
export * from "./HistoryFlash.vue?vue&type=script&lang=js"
import style0 from "./HistoryFlash.vue?vue&type=style&index=0&id=55ab0a91&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ab0a91",
  null
  
)

export default component.exports